<template>
  <div class="getWorkAdvertising">
    <div class="mg-10">
      <div class="basic failed" v-if="detailData.examineStatus == 2">
        <div class="title">
          <van-icon name="failure"/>
          审核不通过
        </div>
        <div class="content">{{ detailData.examineReason }}</div>
      </div>

      <div class="distributionBox clearfix">
        <div class="tip-div" v-if="detailData.infoPercent < 100">
          <van-row>
            <van-col span="14">资料完善度仅{{ detailData.infoPercent }}%</van-col>
            <van-col span="10" style="text-align: right" @click="deletePatch">马上去完善
              <van-icon name="arrow"/>
            </van-col>
          </van-row>
        </div>
        <div class="pg-10">
          <div class="personInformationBox">
            <div>
              <img class="userHeadImg" src="../../assets/images/distribution/paihuo_touxiang_default.png"
                   v-if="!detailData.headImg">
              <img :src="detailData.headImg" v-else class="userHeadImg" @click.stop="imagePreview(detailData.headImg)">
            </div>
            <div class="personInformation">
              <div class="user-name">
                {{ detailData.name }}
              </div>
              <van-tag v-if="detailData.isAuth === 1" plain class="is-auth-tag" size="medium">
                已实名
              </van-tag>
              <van-tag v-else plain color="#999999" text-color="#999999" size="medium">
                未实名
              </van-tag>
              <van-tag v-if="detailData.type === 1" plain color="#8DBEFEFF" text-color="#096CEFFF" size="medium">
                班组
              </van-tag>
              <van-tag v-else-if="detailData.type === 2" plain color="#8DBEFEFF" text-color="#096CEFFF" size="medium">
                企业
              </van-tag>
              <van-tag v-else plain color="#8DBEFEFF" text-color="#096CEFFF" size="medium">
                个人
              </van-tag>
              <van-tag v-if="detailData.workAge" plain color="#8DBEFEFF" text-color="#096CEFFF" size="medium">
                {{ detailData.workAge + '年工龄' }}
              </van-tag>
            </div>
          </div>
<!--          <div class="WRAST" v-for="(val, ind) in detailData.datas" :key="ind" v-if="val.id === 'score'">
            <span class="key-text">{{ val.key }}</span>
            <span class="WRASText" v-if="val.value.socreLevel == -1">黑名单</span>
            <span class="WRASText" v-if="val.value.socreLevel == 0">信用未评级</span>
            <van-rate
              v-model="val.value.starCount"
              :size="25"
              color="#ffd21e"
              void-icon="star"
              void-color="#eee"
            />

            <div class="fr to-edit" @click="deletePatch">
              <van-icon :name="zhaohuo_edit"/>
              去修改
            </div>
          </div>-->
        </div>
      </div>

      <div class="distributionBox basic projectContent ">
        <div class="title">
          <van-icon name="description"/>
          找活信息
        </div>
        <div class="user-city-worker">
          <div class="city-worker-div">
            <div class="city-worker-type">
              <div class="city-worker-title">工作状态</div>

              <div style="width: 100%;text-align: right">
                <div class="work-status">
                  <van-button :class="status == 1 ? 'checked' : ''" round block @click="status = 1">找活中</van-button>
                  <van-button :class="status == 0 ? 'checked' : ''" round block @click="status = 0">暂不找活</van-button>
                </div>
              </div>
              <!--            <van-field v-model="" label="工作状态" placeholder="请输入招工人数" input-align="left"-->
              <!--                       type="digit"/>-->
            </div>
          </div>
          <template v-if="detailData.type !== 2">
            <div class="city-worker-div">
              <van-field v-model="workTypesText" label="我的工种" placeholder="请选择工种" input-align="left" readonly
                         @click="workTypesMethods"/>
            </div>
            <div class="city-worker-div">
              <van-field v-model="citysText" label="期望城市" placeholder="请选择期望工作城市" input-align="left" readonly
                         @click="citysMethods"/>
            </div>
          </template>
        </div>


        <div class="title">
          <van-icon :name="zhaohuo_icon_jieshao"/>
          自我介绍
        </div>

        <div class="info-tip">
          <van-icon class="icon-man" :name="zhaohuo_img_man"/>
          <div class="tip-text">老板想知道，你做过什么？有什么专业技能？接什么样的活儿？

            <div class="van-popover__arrow"></div>
          </div>
        </div>
        <div class="content">
          <van-field id="contentFocus" v-model="content" type="textarea" autosize maxlength="200" rows="7"
                     placeholder="请输入介绍内容（200字以内）"
          />

          <div v-show="muBanIsShow" class="muBanIsShow">
            <img
              src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/zhaogong_icon_shangyige@2x.png"
              @click="shangyige">
            <img src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/zhaogong_icon_xiayige@2x.png"
                 @click="xiayige">
          </div>

          <div class="btn_voiceBox">
            <van-button
              icon="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/zhaogong_icon_muban@2x.png"
              round
              color="#37A1FF"
              @click="btn_muban"
              v-if="!isClearMuban"
            >
              模版输入
            </van-button>
            <van-button
              icon="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/zhaogong_icon_muban@2x.png"
              round
              color="#37A1FF"
              @click="btn_clearMuban"
              v-if="isClearMuban"
            >
              清除模板
            </van-button>
            <van-button
              icon="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/zhaogong_icon_yuyin@2x.png"
              round
              color="#096CEF"
              @click="btn_voice"
            >
              语音输入
            </van-button>
          </div>
        </div>
        <div class="title">
          <van-icon class="icon-file" :name="zhaohuo_icon_tupian"/>
          图片和视频
        </div>

        <div class="info-tip">
          <van-icon class="icon-man" :name="zhaohuo_img_woman"/>
          <div class="tip-text">添加自拍、干活实操、项目成果图片或视频

            <div class="van-popover__arrow"></div>
          </div>
        </div>

        <div class="fileBox">

          <img :src="btn_pic_upload" class="btn_pic_upload file-img" @click="upload">

          <van-dialog
            style="width:100%;border-radius:0;height:200px"
            theme="default"
            v-model="showvideoplay"
            :show-cancel-button="false"
            :show-confirm-button="false"
            closeOnClickOverlay
          >

            <div ref="videobox" id="mui-player"></div>
          </van-dialog>


          <div v-for="(item, index) in attachs" :key="index"
               @click="attachsDetail(item, index)">
            <div style="position: relative">
              <div v-if="item.fileType ==='mp4'" class="videoBox">
                <video :poster="item.attachUrl+'?x-oss-process=video/snapshot,t_1,m_fast'"
                       :src="item.attachUrl"
                       class="video"></video>
                <img src="../../assets/images/publicImg/icon_video_bg.png" class="file-img icon_video_bg">
              </div>
              <img class="file-img" v-else :src="item.attachUrl">
              <van-icon class="icon-attachDelete" :name="create_button_close" @click.stop="attachDelete(index)"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="btn-div">
      <van-button round block color="#096CEF" type="info" @click="illegalWordsCheck(1,'')">立即发布</van-button>
    </div>

    <!--状态-->
    <van-popup v-model="chooseTypeDilog" position="bottom">
      <van-picker
        title="请选择"
        show-toolbar
        :columns="jObStatusList"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>

    <imagePopup v-model="showImagePopup" :imgUrl="imgUrl"/>

    <!--工种-->
    <van-popup v-model="gongZhongIsShow" class="gongZhongBox" position="bottom"
               :style="{ height: '100%',width: '100%' }">
      <selectGongZhongOption @closeGongZhong="closeGongZhong" :workTypesList="workTypesList" ref="selectGongZhong"
                             @close="closeInit"/>
    </van-popup>


    <!--工种-->
    <van-popup v-model="cityIsShow" class="gongZhongBox" position="bottom"
               :style="{ height: '100%',width: '100%' }">
      <selectCityOption @closeCity="closeCity" :citysList="citysList" ref="selectCity"
                        @close="closeCityInit"/>
    </van-popup>

    <!--内容存在违规词的提示-->
    <van-dialog v-model="violationShow" title="内容存在违规词" :showConfirmButton="false" :closeOnClickOverlay="true">
      <div class="violation-div">发布的内容中包含违规词：{{ illegalWords }}，请核实内容后进行发布。</div>
      <div class="bt_H_35 bt_w_125 mb_center">
        <van-button type="info" round @click="violationShow = false">修改</van-button>
      </div>
    </van-dialog>

    <div id="video-ios" style="height: 0"></div>
  </div>
</template>

<script>
import { findJobInit, findJobPublish } from '@api/getJob'
import { pubTempelte } from '@api/invitationBids'
import imagePopup from '@components/imagePopup/imagePopup'
import { ossBrowse } from '@api/oss'
import { jObBanZhuStatusList } from '@/libs/enumerates'
import selectGongZhongOption from '@/components/selectGongZhongOption'
import selectCityOption from '@/components/selectCityOption'
import { illegalWordsCheck } from '@api/project'
import { dataSave } from '@api/coins'
import 'mui-player/dist/mui-player.min.css'
import MuiPlayer from 'mui-player'
import zhaohuo_icon_jieshao from '../../assets/images/distribution/zhaohuo_icon_jieshao.png'
import zhaohuo_icon_tupian from '../../assets/images/distribution/zhaohuo_icon_tupian.png'
import zhaohuo_img_man from '../../assets/images/distribution/zhaohuo_img_man.png'
import zhaohuo_img_woman from '../../assets/images/distribution/zhaohuo_img_woman.png'
import zhaohuo_edit from '../../assets/images/distribution/zhaohuo_edit.png'
import btn_pic_upload from '../../assets/images/publicImg/btn_pic_upload.png'
import create_button_close from '../../assets/images/distribution/create_button_close.png'
import { ImagePreview } from 'vant'

export default {
  name: 'getWorkAdvertising',
  components: {
    imagePopup,
    selectGongZhongOption,
    selectCityOption
  },
  data () {
    return {
      btn_pic_upload: btn_pic_upload,
      zhaohuo_icon_jieshao: zhaohuo_icon_jieshao,
      zhaohuo_icon_tupian: zhaohuo_icon_tupian,
      zhaohuo_img_man: zhaohuo_img_man,
      zhaohuo_img_woman: zhaohuo_img_woman,
      zhaohuo_edit: zhaohuo_edit,
      create_button_close: create_button_close,

      cityList: [], // 城市选项list
      cityIsShow: false, // 城市弹窗
      citys: [], // 城市id
      citysText: '', // 工城市名称
      citysList: [],

      gongZhongList: [], // 工种选项list
      gongZhongIsShow: false, // 工种弹窗
      workTypes: [], // 工种id
      workTypesText: '', // 工种名称
      workTypesList: [],

      illegalWords: '',
      violationShow: false,
      showall: false,
      isEdit: false,
      detailData: {},
      content: '',
      showImagePopup: false,
      imgUrl: '',
      status: 1,
      typeText: '',
      jObStatusList: jObBanZhuStatusList,
      chooseTypeDilog: false,
      attachs: [],
      cityId: '320500',

      carinfo: {
        videofile: '',
        ngEcoOpenNo: ''
      },
      videourl: '',
      showvideoplay: false,
      tempelteList: [], // 模板列表
      muBanIsShow: false,
      tempelteIndex: 0,
      isClearMuban: false,
    }
  },
  created () {
    this.startTime = Date.now()
    // 客户端调用js方法-语音输入
    this.$bridge.registerHandler('SpeechInput', (data, responseCallback) => {
      this.content = this.content + data
      responseCallback(data)
    })
    // 客户端调起刷新事件
    this.$bridge.registerHandler('decodeMethod', (data, responseCallback) => {
      this.decodeMethod(data)
      responseCallback(data)
    })

    if (this.$route.query.cityId && this.$route.query.cityId !== 'undefined') {
      this.cityId = this.$route.query.cityId
      this.getFindJobInit()
    } else {
      let cityId = localStorage.getItem('cityId')
      if (cityId) {
        this.cityId = cityId
        this.getFindJobInit()
      } else {
        this.getFindJobInit()
      }
    }

    // 初始化极光统计
    this.$jiguang.initCountEvent()
  },
  methods: {
    // 打开工种弹窗
    workTypesMethods () {
      this.gongZhongIsShow = true
      this.$nextTick(() => {
        this.$refs.selectGongZhong.initPage()
      })
    },
    // 关闭按钮
    closeGongZhong (data) {
      this.gongZhongIsShow = false
      this.workTypesList = data
      this.workTypesText = (data.map(item => item.name)).toString()
    },
    closeInit () {
      this.gongZhongIsShow = false
    },

    // 打开城市弹窗
    citysMethods () {
      this.cityIsShow = true
      this.$nextTick(() => {
        this.$refs.selectCity.initPage()
      })
    },

    // 关闭按钮
    closeCity (data) {
      this.cityIsShow = false
      this.citysList = data
      this.citysText = (data.map(item => item.text)).toString()
    },
    closeCityInit () {
      this.cityIsShow = false
    },

    // 验证是否含有敏感词 type 1 发布, type 2 置顶
    illegalWordsCheck (type, e) {

      if (this.detailData.type !== 2) {
        // 校验请选择工种
        if (this.workTypesList.length === 0) {
          this.$toastMsg('请选择工种')
          return
        }
        // 校验内容最少5个字
        if (this.citysList.length === 0) {
          this.$toastMsg('请选择期望城市')
          return
        }
      }

      // 校验内容最少5个字
      if (this.content.length < 5) {
        this.$toastMsg('自我介绍最少5个字')
        return
      }

      if (this.status == 0) {
        this.$dialog.confirm({
          message:
            `当前状态为：暂不找活，老板无法看到你的名片`,
          confirmButtonColor: '#096CEFFF',
          confirmButtonText: '修改状态',
          cancelButtonText: '暂不找活'
        })
          .then(() => {
            this.status = 1
          })
          .catch(() => {
            illegalWordsCheck({
              text: this.content
            }).then(res => {
              if (res.data.code === 200) {
                if (res.data.data.contains == 1) {
                  this.illegalWords = res.data.data.illegalWords
                  this.violationShow = true
                } else {
                  if (type == 1) {
                    this.advertiseSeekers()
                  } else {
                    this.onTop(e)
                  }
                }
              } else {
                this.$toastMsg(res.data.msg)
              }
            })
          })
      } else {
        illegalWordsCheck({
          text: this.content
        }).then(res => {
          if (res.data.code === 200) {
            if (res.data.data.contains == 1) {
              this.illegalWords = res.data.data.illegalWords
              this.violationShow = true
            } else {
              if (type == 1) {
                this.advertiseSeekers()
              } else {
                this.onTop(e)
              }
            }
          } else {
            this.$toastMsg(res.data.msg)
          }
        })
      }
    },

    // 点击成功提示确定返回上一页
    seeOthers () {
      this.$bridge.callHandler('backRefresh', response => {
        console.log('response:', response)
      })
    },

    // 获取指定所需邀工币数量
    onTop (e) {
      if (e === 'topFlag') {
        this.advertiseSeekers('topFlag')
      } else {
        this.topByCoin()
      }
    },

    // 置顶
    topByCoin () {

      // 暂时储存临时数据
      let dataJson = {
        dataId: this.detailData.id,
        dataType: '2'
      }

      dataSave(dataJson).then(res => {
        if (res.data.code === 200) {
          let data
          if (this.detailData.isTop == 1) {
            data = {
              url: `${process.env.VUE_APP_BASE_HOST}/top?type=2&uid=` + res.data.data + '&id=' + this.detailData.id,
              title: '找活信息置顶'
            }
          } else {
            data = {
              url: `${process.env.VUE_APP_BASE_HOST}/top?type=2&uid=` + res.data.data,
              title: '找活信息置顶'
            }
          }
          this.$bridge.callHandler('newPage', data, response => {
            console.log('response:', response)
          })
        }
      })
    },

    // 获取找活详情
    getFindJobInit () {
      findJobInit({
        city: this.cityId
      }).then(res => {
        if (res.data.code === 200) {
          this.detailData = res.data.data
          this.content = res.data.data.content
          this.status = res.data.data.status
          if (res.data.data.attachments) {
            this.attachs = res.data.data.attachments
          }

          if (res.data.data.workTypes) {
            this.workTypesList = res.data.data.workTypes
            this.workTypesText = (res.data.data.workTypes.map(item => item.name)).toString()
          }

          if (res.data.data.cities) {
            let cites = res.data.data.cities

            let citysList = []
            for (let i = 0; i < cites.length; i++) {
              citysList.push({
                id: cites[i].cityid,
                text: cites[i].city
              })
            }

            this.citysList = citysList
            this.citysText = (citysList.map(item => item.text)).toString()
          }

        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 修改个人信息,进入资料页面
    deletePatch () {
      this.$bridge.callHandler('jumpPersonInfomation', response => {
        console.log('response:', response)
      })
    },
    // 语音输入
    btn_voice () {
      this.$bridge.callHandler('SpeechInput', response => {
        console.log('response:', response)
      })
    },
    // 发布找活广告
    advertiseSeekers (e) {
      let topFlag = false
      if (e === 'topFlag') {
        topFlag = true
      }

      let browTime = parseInt((Date.now() - this.startTime) / 1000)
      let brow = 'h5_publish_zhaohuo_browser,发布找活广告,找活,' + browTime
      // 初始化极光统计预览时长
      this.$jiguang.initBrowseEvent(brow)
      // 获取极光统计所需数据
      this.$bridge.callHandler('getDeviceInfo', 'h5_publish_zhaohuo', response => {
        console.log('response:', response)
      })

      let dataJson = {
        topFlag: topFlag,
        content: this.content,
        defaultCity: this.detailData.defaultCity,
        isDefalult: this.isEdit === false ? 1 : 2,
        attachments: this.attachs,
        status: this.status
      }

      if (e === 'topFlag') {
        dataSave(dataJson).then(res => {
          if (res.data.code === 200) {
            const data = {
              url: `${process.env.VUE_APP_BASE_HOST}/top?type=1&uid=` + res.data.data,
              title: '找活信息置顶'
            }
            this.$bridge.callHandler('newPage', data, response => {
              console.log('response:', response)
            })
          }
        })
      } else {
        findJobPublish({
          topFlag: topFlag,
          typeWorks: (this.workTypesList.map(item => item.id)).join(','),
          cityCode: (this.citysList.map(item => item.id)).join(','),
          content: this.content,
          defaultCity: this.detailData.defaultCity,
          isDefalult: this.isEdit === false ? 1 : 2,
          attachments: this.attachs,
          status: this.status
        }).then(res => {
          if (res.data.code === 200) {
            // 暂不找活直接返回招工列表页
            if (this.status == 0) {
              this.$toastMsg('操作成功')
              let that = this
              setTimeout(function () {
                that.$bridge.callHandler('backJobList', response => {
                  console.log('response:', response)
                })
              }, 500)

            } else {
              const data = {
                url: `${process.env.VUE_APP_BASE_HOST}/getJobPublishSuccess?id=${res.data.data}&isTop=${this.detailData.isTop}&type=${this.detailData.type}`,
                title: '发布成功'
              }
              this.$bridge.callHandler('newPage', data, response => {
                console.log('response:', response)
              })
            }
          } else {
            this.$toastMsg(res.data.msg)
          }
        })
      }
    },

    // 流程弹窗选择确定
    onConfirm (value) {
      this.status = value.id
      this.typeText = value.text
      this.chooseTypeDilog = false
    },

    // 流程弹窗取消
    onCancel () {
      this.chooseTypeDilog = false
    },
    imagePreview (imgUrl) {
      this.showImagePopup = true
      this.imgUrl = imgUrl
    },
    upload () {
      const data = {
        bucket: 'yiyong-pub',
        path: 'project/bidding/',
        type: 0 // 0-不上传文件，1-上传文件
      }
      this.$bridge.callHandler('uploadMethod', data, response => {
        console.log('response:', response)
      })
    },
    // 解密
    decodeMethod (data) {
      this.attachs.push({
        attachName: (decodeURIComponent(data)).substring(data.lastIndexOf('/') + 1),
        attachUrl: data,
        fileType: data.substring(data.lastIndexOf('.') + 1) // 文件后缀名
      })
    },
    // 下载附件
    attachsDetail (file, index) {

      if (file.fileType === 'mp4') {
        // this.$bridge.callHandler('newPage', { url: file.attachUrl }, response => {
        //   console.log('response:', response)
        // })
        // return
        // 判断ios还是安卓
        const u = navigator.userAgent
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
        if (isiOS) {

          const video = document.getElementById('playVideos')
          if (video) {
            video.remove()
          }

          let str = document.createElement('video')
          str.id = 'playVideos'
          str.src = file.attachUrl
          str.setAttribute('type', 'video/mp4')
          str.setAttribute('controls', 'controls')
          str.style.width = '0'
          str.style.height = '0'
          str.play()
          document.getElementById('video-ios').append(str)
        } else {

          this.$bridge.callHandler('newPage', { url: file.attachUrl }, response => {
            console.log('response:', response)
          })
          return

          this.showvideoplay = true

          setTimeout(function () {
            // 初始化 MuiPlayer 插件，MuiPlayer 方法传递一个对象，该对象包括所有插件的配置
            var mp = new MuiPlayer({
              container: '#mui-player',
              title: '视频',
              src: file.attachUrl,
              preload: 'auto',
              autoplay: true
            })
          }, 500)
        }
      } else {
        let list = []
        for (let i = 0; i < this.attachs.length; i++) {
          if (this.attachs[i].fileType !== 'mp4') {
            list.push(this.attachs[i].attachUrl)
          } else {
            if (i <= index) {
              index = index - 1
            }
          }
        }

        ImagePreview({
          images: list,
          showIndex: true,
          loop: false,
          startPosition: index
        })
      }
    },
    attachDelete (index) {
      this.attachs.splice(index, 1)
    },

    // 模板输入
    btn_muban () {
      pubTempelte({
        pubType: 2
      }).then(res => {
        if (res.data.code === 200) {
          this.tempelteList = res.data.data
          // 解析工种
          // this.typeOfWorkMatchMethod()
          if (res.data.data.length > 1) {
            this.tempelteIndex = 0
            this.muBanIsShow = true
            this.content = res.data.data[0].label
          } else {
            this.isClearMuban = true
            this.content = res.data.data[0].label
          }
          document.getElementById('contentFocus').focus()
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 清除模板
    btn_clearMuban () {
      this.content = ''
      this.isClearMuban = false
    },

    // 上一个模板
    shangyige () {
      if (this.tempelteIndex === 0) {
        this.tempelteIndex = this.tempelteList.length - 1
        this.content = this.tempelteList[this.tempelteIndex].label
      } else {
        this.tempelteIndex = this.tempelteIndex - 1
        this.content = this.tempelteList[this.tempelteIndex].label
      }
    },

    // 下一个模板
    xiayige () {
      if (this.tempelteIndex === this.tempelteList.length - 1) {
        this.tempelteIndex = 0
        this.content = this.tempelteList[0].label
      } else {
        this.tempelteIndex = this.tempelteIndex + 1
        this.content = this.tempelteList[this.tempelteIndex].label
      }
    },
  }
}
</script>

<style lang="scss">
@import "../../assets/css/mixin";

.user-city-worker {

  .city-worker-div {
    //display: flex;
    align-items: center;

    .city-worker-type {
      display: flex;
      align-items: center;
      padding-bottom: 10px;

      .city-worker-title {
        @include add_size($font_size_16);
        //margin-right: 10px;
        width: 100%;
      }

      .work-status {
        display: flex;
        background-color: #EBEBEBFF;
        border-radius: 25px;
      }

      .van-button {
        background-color: #ebebeb;
        color: #666666FF;
        height: 28px;
        width: 90px;
      }

      .checked {
        background-color: #37A1FFFF;
        color: #FFFFFF;
      }
    }

    .van-cell {
      padding: 5px 0;
      display: flex;
      align-items: center;

      .van-field__label {
        width: auto;
        font-weight: normal;
        @include add_size($font_size_16);
      }

      .van-cell__value {
        background-color: #EFF6FF;
        border: 0.02667rem solid #7EC3FF;
        border-radius: 0.13333rem;
        padding: 3px 5px;
      }

      //@include add_size($font_size_16);
    }
  }

}

#mui-player {
  height: 200px !important;
}

.van-uploader {
  padding-top: 10px;
}

.van-uploader__upload {
  //display: none;
}

.user-name {
  @include add_size($font_size_17);
}

.van-tag {
  background-color: #096CEF12;
  @include add_size($font_size_13);
  margin-right: 3px;
  padding: 3px 5px;
}

.distributionBox {
  margin-top: 0;
  padding: 0;
  border-radius: 5px;

  .tip-div {
    border-radius: 5px 5px 0 0;
    background-color: #F6B224FF;
    color: #FFFFFF;
    padding: 10px;
    @include add_size($font_size_15);

    .van-icon {
      vertical-align: -15%;
    }
  }

  .pg-10 {
    padding: 10px;
  }
}

.icon-file {
  vertical-align: -15%;
  padding-right: 5px;
}

/*.WRAST {
  padding: 10px 0;

  .key-text {
    color: #999;
    margin-right: 3px;
    @include add_size($font_size_17);
  }
}*/

.to-edit {
  padding-top: 2px;
  color: #096CEFFF;
  @include add_size($font_size_16);

  .van-icon {
    @include add_size($font_size_20);
    vertical-align: -20%;
  }
}

.info-tip {
  @include add_size($font_size_16);
  padding: 10px 0;
  display: flex;

  .tip-text {
    margin-left: 10px;
    padding: 7px;
    background-color: #F7F8FAFF;
    border-radius: 5px;
    position: relative;
  }

  .van-popover__arrow {
    position: absolute;
    top: 50%;
    left: 0;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    border-width: 6px;
    color: #F7F8FAFF;
    //top: 50%;
    /* left: 0; */
    border-right-color: currentColor;
    border-left-width: 0;
    -webkit-transform: translate(-100%, -50%);
    transform: translate(-100%, -50%);
  }
}

.van-rate {
  vertical-align: -15%;
}

.van-rate__icon {
  display: none;
}

.van-rate__icon--full {
  display: block;
}

.icon-man, .icon-woman {
  @include add_size($font_size_60);
}

.userHeadImg {
  height: 55px;
  width: 55px;
  border-radius: 5px;
}

.getWorkAdvertising {
  font-size: 20px;
  padding-bottom: 60px;
  margin: 10px 0;

  .mg-10 {
    margin: 0 10px;
  }

  .failed {
    margin-top: 10px;
    border: 1px solid rgba(242, 54, 54, 0.5);
    background-color: #F236360D;

    padding: 10px;

    .title {
      color: #F23636FF;
      @include add_size($font_size_20);
      padding-bottom: 5px;

      .van-icon {
        @include add_size($font_size_20);
        vertical-align: -15%;
      }
    }

    .content {
      @include add_size($font_size_16);
    }
  }

  .van-field__control {
    @include add_size($font_size_16);
    line-height: 26px;
  }

  .btn_edit {
    width: 100px;
    height: 30px;
    margin-top: 8px;
  }

  .projectContent {
    padding: 10px;

    .title {
      font-weight: bolder;
      @include add_size($font_size_18);
    }

    .content {
      background-color: #EFF6FFFF;
      border: 1px solid #7EC3FF;
      border-radius: 5px;
      padding: 5px 0;
      position: relative;
      margin-bottom: 10px;

      .van-cell {
        padding-top: 0;
        padding-bottom: 0 !important;
      }

      .van-field__control {
        background: #EFF6FFFF;
        padding: 10px;
      }
    }


    .btn_voice {
      width: 100px;
      height: 30px;
      position: absolute;
      right: 10px;
      bottom: 20px;
    }
  }

  .information {
    @include add_size($font_size_17);
    color: #333;
    font-weight: 400;
    margin-top: 4px;

    span {
      color: #999999;
    }
  }

  .typeText {
    .van-field__control {
      background: #fff;
      padding: 0;
    }
  }

  .buttonStyle {
    width: 70%;
    height: 40px;
    line-height: 40px;
    opacity: 1;
    border-radius: 50px;
    font-size: 17px;
    text-align: center;
    color: #FFFFFF;
  }

  .publishStyle {
    background: #096CEF;
    margin: 20px auto 0;
  }

  .editPublishStyle {
    background: #096CEF;
  }

  .draftSubmit {
    background: #FFB111;
    margin-left: 25px;
  }

  .topSubmit {
    background: #71D15FFF;
    margin-left: 25px;
  }

  .btn-div {
    z-index: 999;
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 60px;
    bottom: 0;
    background: #fff;
    text-align: center;

    .van-button {
      height: 36px;
      line-height: 36px;
      @include add_size($font_size_17);
      width: 70%;
    }
  }

  .fileBox {
    display: flex;
    flex-wrap: wrap;

    .file-img {
      width: 80px;
      height: 80px;
      margin-top: 10px;
      margin-left: 10px;
      flex-shrink: 0;
    }

    .videoBox {
      width: 80px;
      height: 80px;
      margin-top: 10px;
      margin-left: 10px;
    }

    .icon_video_bg {
      width: 80px;
      height: 80px;
      position: absolute;
      top: -10px;
      left: 0;
      z-index: 0;
    }

    .video {
      width: 100%;
      height: 100%;
      object-fit: fill;
    }

    .icon-attachDelete {
      font-size: 19px;
      color: #FFFFFF;
      position: absolute;
      top: 0;
      right: 0;
    }
  }
}

.projectContent {
  position: relative;
  padding: 10px;

  .btn_voiceBox {
    height: 45px;
    background: #EFF6FF;
    display: flex;
    justify-content: space-between;
    padding: 0 10px;

    .van-button {
      width: 144px;
      height: 32px;

      .van-button__text {
        @include add_size($font_size_14);
      }
    }
  }

  .muBanIsShow {
    background: #EFF6FF;
    display: flex;
    justify-content: center;
    padding: 16px;

    img {
      width: 65px;
      height: 21px;

      &:first-child {
        margin-right: 28px;
      }
    }
  }
}
</style>
